if (!customElements.get('klaviyo-subscription-form')) {
  customElements.define(
    'klaviyo-subscription-form',
    class KlaviyoSubscribe extends HTMLElement {
      constructor() {
        super();
        this.companyId = 'VqyMEb';
        this.fields = this.querySelectorAll('[data-option]');
        this.heading = this.querySelector('[data-heading]');
        this.defaultTitle = this.querySelector('[data-heading-default]');
        this.defaultMessage = this.querySelector('[data-message-default]');
        this.phoneTitle = this.querySelector('[data-heading-phone]');
        this.phoneMessage = this.querySelector('[data-phone-message]');
        this.defaultPrivacy = this.querySelector('[data-default-privacy]');
        this.phonePrivacy = this.querySelector('[data-phone-privacy]');
        this.succesTitle = this.querySelector('[data-message-title]');
        this.successMessage = this.querySelector('[data-message]');
        this.errorMessage = this.querySelector('[data-error]');
        this.phoneErrorMessage = this.querySelector('[data-phone-error]');
      }

      get listId() {
        return this.dataset.id;
      }

      get smsId() {
        return this.dataset.smsId;
      }

      get whatsappId() {
        return this.dataset.whatsappId;
      }

      get options() {
        return this.dataset.options;
      }

      get source() {
        return this.dataset.source;
      }

      #email = '';

      connectedCallback() {
        this.initForm();
      }

      initForm() {
        this.fields.forEach((field) => {
          const input = field.querySelector('input');
          const button = field.querySelector('button');
          if (window.innerWidth >= 990) {
            input.addEventListener('keydown', (event) => {
              if (event.code === 'Enter') this.setupConditions(field, input);
            });
          }
          button.addEventListener('click', () => this.setupConditions(field, input));
        });
      }

      setupConditions(field, input) {
        switch (this.options) {
          case 'email':
            if (!this.validateEmail(input.value)) {
              input.classList.add('error');
              this.errorMessage.classList.remove('hidden');
            } else {
              input.classList.remove('error');
              this.errorMessage.classList.add('hidden');
              this.#email = input.value;
              this.sendDataToKlaviyo(input);
            }
            break;
          case 'phone':
            if (!this.validatePhone(input.value)) {
              input.classList.add('error');
              this.phoneErrorMessage.classList.remove('hidden');
            } else {
              input.classList.remove('error');
              this.phoneErrorMessage.classList.add('hidden');
              this.sendDataToKlaviyo(input);
            }
            break;
          case 'both':
            if (input.name == 'email') {
              if (!this.validateEmail(input.value)) {
                input.classList.add('error');
                this.errorMessage.classList.remove('hidden');
              } else {
                input.classList.remove('error');
                this.errorMessage.classList.add('hidden');
                field.classList.add('hidden');
                field.nextElementSibling.classList.remove('hidden');
                if (this.phoneTitle) {
                  this.defaultTitle.classList.add('hidden');
                  if (this.defaultMessage) {
                    this.defaultMessage.classList.add('hidden');
                  }
                  this.phoneTitle.classList.remove('hidden');
                }
                if (this.phoneMessage) this.phoneMessage.classList.remove('hidden');
                if (this.phonePrivacy) {
                  this.defaultPrivacy.classList.add('hidden');
                  this.phonePrivacy.classList.remove('hidden');
                }
                this.#email = input.value;
                this.sendDataToKlaviyo(input, true);
              }
            } else {
              if (!this.validatePhone(input.value)) {
                input.classList.add('error');
                this.phoneErrorMessage.classList.remove('hidden');
              } else {
                input.classList.remove('error');
                this.phoneErrorMessage.classList.add('hidden');
                this.sendDataToKlaviyo(input, false);
              }
            }
            break;
        }
      }

      async sendDataToKlaviyo(input, skip = false) {
        const url = `https://a.klaviyo.com/client/subscriptions?company_id=${this.companyId}`;
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-10-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify(this.requestData(input)),
        };

        try {
          const response = await fetch(url, options);
          if (response.status !== 202) return;
          this.handleSuccess(skip);
        } catch (error) {
          console.error(error);
        }
      }

      requestData(input) {
        let request = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    subscriptions: {},
                  },
                },
              },
              custom_source: this.source
            },
            relationships: { list: { data: { type: 'list', id: '' } } },
          },
        };
        const value_type = input.name;
        if (value_type === 'email') {
          request.data.attributes.profile.data.attributes.email = input.value;
          request.data.attributes.profile.data.attributes.subscriptions.email = {
            marketing: {
              consent: 'SUBSCRIBED',
            },
          };
          request.data.relationships.list.data.id = this.listId;
        } else {
          request.data.attributes.profile.data.attributes.email = this.#email;
          request.data.attributes.profile.data.attributes.phone_number = input.value.replace(/\s/g, '');
          const countryCode = input.value.slice(0, 2);
          switch (countryCode) {
            case '+1':
              request.data.attributes.profile.data.attributes.subscriptions.sms = {
                marketing: {
                  consent: 'SUBSCRIBED',
                },
                transactional: {
                  consent: 'SUBSCRIBED',
                },
              };
              request.data.relationships.list.data.id = this.smsId;
              break;
            default:
              request.data.attributes.profile.data.attributes.subscriptions.whatsapp = {
                marketing: {
                  consent: 'SUBSCRIBED',
                },
                transactional: {
                  consent: 'SUBSCRIBED',
                },
              };
              request.data.relationships.list.data.id = this.whatsappId;
              break;
          }
        }

        return request;
      }

      validateEmail(value) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        return regex.test(value);
      }

      validatePhone(value) {
        let valid = false;
        const validator = window.libphonenumber;
        try {
          const number = validator.parsePhoneNumberWithError(value);
          if (!number) valid = false;
          if (number.isPossible()) valid = true;
        } catch (error) {
          if (error instanceof validator.ParseError) {
            valid = false;
          }
        }

        return valid;
      }

      handleSuccess(skip) {
        window.dispatchEvent(new CustomEvent('newsletter-form-submited'));
        if (skip) return;
        this.fields.forEach((field) => field.classList.add('hidden'));
        this.heading.classList.add('hidden');
        if (this.defaultMessage) this.defaultMessage.classList.add('hidden');
        if (this.defaultPrivacy) this.defaultPrivacy.classList.add('hidden');
        if (this.phoneMessage) this.phoneMessage.classList.add('hidden');
        if (this.phonePrivacy) this.phonePrivacy.classList.add('hidden');
        this.succesTitle.classList.remove('hidden');
        this.successMessage.classList.remove('hidden');
      }
    },
  );
}

if (!customElements.get('newsletter-popup')) {
  customElements.define(
    'newsletter-popup',
    class NewsletterPopup extends HTMLElement {
      constructor() {
        super();
        this.hideButtons = this.querySelectorAll('[data-close]');
        this.newsletterHidden = localStorage.getItem('newsletter-bar-hidden');
        this.init();
      }

      get delay() {
        return Number(this.dataset.delay);
      }

      init() {
        if (this.newsletterHidden) return;
        setTimeout(() => {
          this.classList.add('visible');
        }, this.delay);

        this.hideButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.classList.remove('visible');
            localStorage.setItem('newsletter-bar-hidden', true);
          });
        });
      }
    },
  );
}
